export default function (nga, admin, menu) {
    var _ename = 'gold';
    var _epretty = 'Gold Credits Subscriptions';
    var _entity = nga.entity(_ename).readOnly();
    
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);

    
    _entity.listView()
        .title(_epretty)
        .filters([
            nga.field('type', 'choice').choices([{ value: 'kantatu', label: 'Kantatu' },{ value: 'kantatuhd', label: 'Kantatu HD' }]).pinned(true)
        ])
        .fields([
            nga.field('id', 'reference')
                .targetEntity(nga.entity('users'))
                .targetField(nga.field('email'))
                .label('User'),
            nga.field('attributes.kantatu_available_gold_credits').label('Créditos Kantatu'),
            nga.field('attributes.kantatuhd_available_gold_credits').label('Créditos Kantatu HD')
        ]);

    admin.addEntity(_entity);
    
    menu.addChild(nga.menu(_entity).title(_epretty));
    
    return _entity;
}


// WEBPACK FOOTER //
// ./js/entities/gold.js